<template>
  <input type="hidden" v-model="value" :id="identifier" :name="identifier" />
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-hidden"
};
</script>
